import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

type Props = {
  status: string
  message: string
}

export default function BusinessRegistrationUkDashboard({ status, message }: Props) {
  return (
    <DashboardLayout title="UK Registration">
      <Card>
        <CardHeader>
          <CardTitle>UK Module</CardTitle>
        </CardHeader>
        <CardContent className="text-sm">
          {status}: {message}
        </CardContent>
      </Card>
    </DashboardLayout>
  )
}
